/**
 * Tiny in-game ball glyph per PvP league: Great Ball for Great League, Ultra
 * Ball for Ultra, Master Ball for Master. Pure SVG — the self-hosted sprite
 * CDN carries Pokémon art, not item art, so drawing the three balls keeps
 * this offline and theme-independent.
 *
 * Shared by the My Pokémon detail page's PvP IVs rows and the list's
 * top-1% dot-rail badge (2026-08-21).
 */
export type LeagueBallLeague = "little" | "great" | "ultra" | "master";

export function LeagueBall({ league, size = 18 }: { league: LeagueBallLeague; size?: number }) {
  const shell = "hsl(230 15% 28%)";
  // Little League gets the plain red Poké Ball; the others their own ball.
  const top =
    league === "little"
      ? "hsl(0 75% 52%)"
      : league === "great"
        ? "hsl(210 85% 52%)"
        : league === "ultra"
          ? "hsl(230 15% 22%)"
          : "hsl(276 60% 52%)";
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" aria-hidden className="shrink-0">
      <circle cx="10" cy="10" r="9" fill="white" stroke={shell} strokeWidth="1.3" />
      <path d="M1.3 10 a8.7 8.7 0 0 1 17.4 0 Z" fill={top} />
      {league === "ultra" && (
        <path
          d="M3.6 5.6 a8.7 8.7 0 0 1 12.8 0 L14.2 7.9 a5.6 5.6 0 0 0 -8.4 0 Z"
          fill="hsl(48 95% 55%)"
        />
      )}
      {league === "master" && (
        <>
          <circle cx="6.4" cy="6.2" r="1.7" fill="hsl(320 75% 68%)" />
          <circle cx="13.6" cy="6.2" r="1.7" fill="hsl(320 75% 68%)" />
        </>
      )}
      <rect x="1" y="9.2" width="18" height="1.7" fill={shell} />
      <circle cx="10" cy="10" r="2.7" fill="white" stroke={shell} strokeWidth="1.5" />
    </svg>
  );
}
